import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { DefaultRoute } from "@src/router/routes";
import { getHomeRouteForLoggedInUser } from "@src/utility/Utils";

import { isPathAccessibleForUser } from "./routeAccess";
import { useCheckPermission } from "./useCheckPermission";

/** Redirect when refreshed permissions no longer allow the current route. */
const PermissionRouteGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkPermission, isSuperAdmin } = useCheckPermission();
  const { user, permissionCatalogLoading } = useSelector((state: any) => state.auth);
  const userPermissionIds = useSelector(
    (state: any) => state.auth.userPermissionIds
  );

  useEffect(() => {
    if (permissionCatalogLoading || isSuperAdmin) return;

    if (isPathAccessibleForUser(location.pathname, checkPermission)) return;

    const homeRoute =
      user?.roleName != null
        ? getHomeRouteForLoggedInUser(user.roleName)
        : DefaultRoute;

    navigate(homeRoute, { replace: true });
  }, [
    location.pathname,
    userPermissionIds,
    checkPermission,
    permissionCatalogLoading,
    isSuperAdmin,
    navigate,
    user?.roleName,
  ]);

  return null;
};

export default PermissionRouteGuard;
